import BaseViewModel from "./BaseViewModel";
import PageViewModel from "./PageViewModel";

class PageContainerViewModel extends BaseViewModel {

	Pages: Array<PageViewModel> = [];

	Validate = () => {
		let valid = true;
		for ( let i = 0; i < this.Pages.length; i++ ) {
			valid = this.Pages[i].Validate() && valid;
		}
		return valid;
	};

	// SimpleFormat
	getSimpleFormatXmlTagName = () => 'Form';

	override getSimpleFormatXmlOpen = ( id?: string ) => {
		let xml = '<' + this.getSimpleFormatXmlTagName() + ' idRef="page_' + id + '" title=""';
		return xml + '>';
	};

};

export default PageContainerViewModel;
